import { c as _c } from "react/compiler-runtime";
import React from 'react';
import AdvancedSearchProductsGrid from '../AdvancedSearchProductsGrid';
import AdvancedSearchLoadMoreButtons from '../AdvancedSearchProductsGrid/AdvancedSearchLoadMoreButtons';

// Grid shown before the first Algolia search completes: the server-fetched
// products with eager images, padded with in-grid placeholders up to
// expectedCount. A `null` product entry also renders as a placeholder, holding
// the slot of a product that can't be pre-rendered so the rest keep their
// final positions. The load-more block matches the one the real grid renders,
// keeping that space reserved so content below doesn't shift on takeover.
const InitialProductsGrid = t0 => {
  const $ = _c(11);
  const {
    products,
    expectedCount,
    loadMoreButtonsProps
  } = t0;
  let t1;
  if ($[0] !== expectedCount || $[1] !== products) {
    t1 = products.slice(0, expectedCount);
    $[0] = expectedCount;
    $[1] = products;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const productsToShow = t1;
  const t2 = productsToShow.length;
  const t3 = Math.max(0, expectedCount - productsToShow.length);
  let t4;
  if ($[3] !== productsToShow || $[4] !== t3) {
    t4 = <AdvancedSearchProductsGrid products={productsToShow} eagerImageCount={t2} trailingPlaceholderCount={t3} />;
    $[3] = productsToShow;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== loadMoreButtonsProps) {
    t5 = loadMoreButtonsProps && <AdvancedSearchLoadMoreButtons {...loadMoreButtonsProps} />;
    $[6] = loadMoreButtonsProps;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default InitialProductsGrid;